<template>
    <div :class="$options.name" :style="{ color: color }">
        Shout out to 
            <a 
                class="url"
                rel="noopener noreferrer"
                :style="{ color: color }"
                href="https://www.linkedin.com/in/dalilaiapichino/" 
            >
                @DaLee
            </a>
        for the logo design <font-awesome-icon class="heart" icon="heart" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'mentions',
    computed: {
        ...mapGetters({
            themeColor: 'themeColor',
            isMenuOpen: 'isMenuOpen'
        }),
        color() {
            if (this.isMobileSize) {
                if (this.isMenuOpen) {
                    return 'var(--bg-color)'
                }
            }
            return this.$route.name === 'home' ? '#fff' : this.themeColor
        }
    }
}
</script>
<style lang="scss" scoped>
.mentions {
    left: 0;
    z-index: 1;
    width: 100%;
    bottom: 3rem;
    font-size: 0.8rem;
    text-align: center;
    position: absolute;
    .heart {
        path {
            fill: #d20000;
        }
    }
    @include g-state(tablet) {
        left: 1rem;
        width: 100%;
        bottom: 1rem;
        position: fixed;
        text-align: left;
        max-width: 20rem;
    }
}
</style>